export const CEO_SESSION_STORAGE_KEY = 'unit1-ceo-analytics-authenticated';

export const CEO_PIN_ATTEMPT_STATE_KEY = 'unit1-ceo-pin-attempt-state';

export const CEO_ANALYTICS_VIEW = 'ceo-analytics';
